import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name", "description", "id", "type", "categories", "duration", "numberOfLessons", "badge", "onClick", "href", "footerHref", "thumbnailUrl", "to", "showFooter"];
import styled, { theme } from 'academy-common-lib/utils/Styling';
import { getDisplayCategories } from 'academy-common-lib/utils/categories';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ACContentCard from 'academy-common-lib/components/card/ACContentCard';
import ACThumbnailOverlay from 'academy-common-lib/components/card/ACThumbnailOverlay';
// @ts-expect-error Could not find a declaration file for module
import FormattedDuration from 'I18n/components/FormattedDuration';
import UIButton from 'UIComponents/button/UIButton';
import UIBadge from 'UIComponents/badge/UIBadge';
import { resize } from 'FileManagerCore/utils/resize';
import { getLocationDescriptor } from '../../../utils/routing';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReadoutLessonBox = styled(UIBox).withConfig({
  displayName: "PublicContentCard__ReadoutLessonBox",
  componentId: "sc-1p35orw-0"
})(["display:flex;&::after{content:'';margin:0 10px 0 10px;display:inline-flex;align-self:center;border-left:1px solid ", ";height:10px;}"], theme.colors.BATTLESHIP);
const StartCtaMessage = {
  COURSE: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.startCta.course"
  }),
  CERTIFICATION: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.startCta.certification"
  }),
  LESSON: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.startCta.lesson"
  })
};
const BadgeMessage = {
  POPULAR: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.badge.popular"
  }),
  NEW: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.badge.new"
  }),
  UPDATED: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.badge.updated"
  })
};
const PublicContentCard = _ref => {
  let {
      name,
      description,
      id,
      type,
      categories,
      duration,
      numberOfLessons,
      badge,
      onClick,
      href,
      footerHref,
      thumbnailUrl,
      to,
      showFooter = true
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const resizedThumbnailUrl = thumbnailUrl ? resize(thumbnailUrl, {
    length: 400
  }) : undefined;
  return /*#__PURE__*/_jsx(ACContentCard, Object.assign({
    description: description,
    footer: showFooter && /*#__PURE__*/_jsx(UIButton, {
      block: true,
      href: footerHref || href,
      onClick: e => e.stopPropagation(),
      use: "tertiary",
      children: StartCtaMessage[type]
    }),
    href: href,
    id: id,
    name: name,
    onClick: onClick,
    style: {
      maxWidth: 400
    },
    thumbnailOverlay: /*#__PURE__*/_jsx(ACThumbnailOverlay, {
      badge: badge && BadgeMessage[badge],
      categories: getDisplayCategories(categories),
      contentType: type,
      footer: /*#__PURE__*/_jsxs(UIFlex, {
        children: [numberOfLessons && /*#__PURE__*/_jsx(ReadoutLessonBox, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-test-id": "track-total-lessons",
            message: "academyPublic.contentCard.numLessonsRemainingUnstarted",
            options: {
              remainingNumber: numberOfLessons
            }
          })
        }), duration && /*#__PURE__*/_jsx(UIBox, {
          children: /*#__PURE__*/_jsx(FormattedDuration, {
            format: "medium",
            from: +new Date() - duration * 1000
          })
        })]
      }),
      children: badge && /*#__PURE__*/_jsx(UIBadge, {
        style: {
          height: 'fit-content',
          position: 'absolute',
          right: 12,
          top: 12
        },
        use: "koala",
        children: BadgeMessage[badge]
      })
    }),
    thumbnailSrc: resizedThumbnailUrl,
    to: getLocationDescriptor(to)
  }, restProps));
};
export default PublicContentCard;